// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3L1Xh","controls":"styles_controls__1QMDT","charLimit":"styles_charLimit__ZaBnQ","input":"styles_input__2ohlb","send":"styles_send__36srr"};